import { Collection } from 'modules/core/lib/mobx-rest'

import { CustomPeriod } from 'modules/attendance/store/models/Period'

class CustomPeriods extends Collection<CustomPeriod> {
  get cacheKey(): string {
    return 'customPeriods'
  }

  model() {
    return CustomPeriod
  }
}

const singleton: CustomPeriods = new CustomPeriods()

export default singleton
